import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScriptEditorControlsService {
  private editorControlSubscription = new Subject<any>();
  private visibilitySubscription = new Subject<any>();

  constructor() { }

  onControlClick(control: any) {
    this.editorControlSubscription.next(control);
  }

  watchControlEventChanges() {
    return this.editorControlSubscription.asObservable();
  }

  isHeaderEnabled(isEnabled: boolean) {
    this.visibilitySubscription.next(isEnabled);
  }

  onVisibilityChange() {
    return this.visibilitySubscription.asObservable();
  }
}
